import { PlanModelInfo, planTypes } from '@/common/constants';
import { defaultMapper } from '@/common/service/default-mapper';
import { planUnitMap } from '@/common/product-unit';

const clipsCategory = {
  zoom_clips: { typeNameKey: 'billing.zoom_clips_plus.title', planNameKey: 'billing.zoom_clips_plus.title' },
};

export default (planMapJSON = {}) => {

  return Object.keys(clipsCategory).reduce((pre, key) => {
    return [
      ...defaultMapper(planMapJSON[key], planTypes.ZOOM_CLIPS).map(item => ({
        ...item,
        ...clipsCategory[key],
        standAlone: true,
        planModel: PlanModelInfo.license,
        unit: planUnitMap.user,
      })),
      ...pre,
    ];
  }, []);
}
